const n={},r=t=>{let e=n[t];return e||(e=document.createElement("template"),e.innerHTML=t,n[t]=e),e},o=(t,e,c)=>{t.dispatchEvent(new CustomEvent(e,{bubbles:!0,detail:c}))};export{o as fire,r as tpl};
